var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect } from "react";
import { AppContext } from "../appContext";
import { ChatSessionConnectedWithEnum, MessageByTypeEnum, } from "../Models";
import ChatMessage from "./ChatMessage";
import TimeAgo from "../Timeago";
var UserChatMessage = function (props) {
    var _a;
    var parentContext = useContext(AppContext);
    useEffect(function () {
        return function () { };
    }, []);
    var getMessageTime = function () {
        // let myDate = new Date(props.message.created_time * 1000);
        // let dateStr = myDate.getDate() + "/" + (myDate.getMonth() + 1) + "/" + myDate.getFullYear()
        // //+ " " + myDate.getHours() + ":" + myDate.getMinutes() + ":" + myDate.getSeconds()
        // return dateStr;
        return props.message.created_time * 1000;
    };
    var getSession = function () {
        return parentContext.sessions.find(function (session) { return session.id == props.sessionId; });
    };
    var canShowAnavailableMessage = function () {
        var _a, _b, _c;
        var from = MessageByTypeEnum[props.message.from];
        var xyz = (_a = props.nextMessage) === null || _a === void 0 ? void 0 : _a.from;
        var nextFrom;
        if (xyz)
            nextFrom = MessageByTypeEnum[xyz];
        try {
            if (!parentContext.chatPrefs.systemMessage
                .CHAT_MESSAGE_OFFLINE_STATUS_MESSAGE_ENABLED ||
                !((_b = parentContext.chatPrefs.systemMessage.CHAT_MESSAGE_OFFLINE_STATUS_MESSAGE) === null || _b === void 0 ? void 0 : _b.trim()) ||
                from != MessageByTypeEnum.Visitor ||
                !props.message.agents_unavailable ||
                ((_c = props.nextMessage) === null || _c === void 0 ? void 0 : _c.from) === MessageByTypeEnum.GPT)
                return false;
            var canShowUnavailabiltyInCurrentMessage = from == MessageByTypeEnum.Visitor && props.message.agents_unavailable;
            if ((!props.message.nextMessage && canShowUnavailabiltyInCurrentMessage) ||
                (canShowUnavailabiltyInCurrentMessage &&
                    props.nextMessage &&
                    (nextFrom != MessageByTypeEnum.Visitor ||
                        !(nextFrom == MessageByTypeEnum.Visitor &&
                            props.nextMessage.agents_unavailable)))) {
                return true;
            }
            return false;
        }
        catch (error) {
            return false;
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "chat__messages-group chat__messages-group--me" }, { children: [_jsxs("div", __assign({ className: "chat__messages-header" }, { children: [_jsx("p", { children: _jsxs("div", { children: [_jsx("span", __assign({ className: "chat__messages-header-user" }, { children: "You " })), " |", _jsx("span", __assign({ className: "chat__messages-header-timeago" }, { children: props.message.status == "SENDING" ? ("Sending ...") : (_jsx(TimeAgo, { date: getMessageTime() })) }))] }) }), props.message.status == "SENDING" ? (_jsx("span", __assign({ className: "message-sent-status" }, { children: "Sending ..." }))) : (_jsx(_Fragment, {})), props.message.status == "FAILED" ? (_jsx("span", __assign({ className: "message-sent-error" }, { children: "Failed" }))) : (_jsx(_Fragment, {}))] })), _jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("li", __assign({ className: "chat__messages-list-item" }, { children: _jsx(ChatMessage, { sessionId: props.sessionId, message: props.message, updateMessage: function () { } }) })) })), canShowAnavailableMessage() && ((_a = getSession()) === null || _a === void 0 ? void 0 : _a.connected_with) === ChatSessionConnectedWithEnum.AGENT ? (_jsx("div", __assign({ className: "chat__messages-footer" }, { children: _jsx("div", __assign({ style: {
                            background: "rgb(207, 237, 239)",
                            border: "1px solid rgb(206, 232, 241)",
                            borderRadius: "3px",
                            color: "rgb(57, 92, 96)",
                            fontSize: "10px",
                            padding: "5px",
                            textAlign: "center",
                            marginTop: "5px",
                        } }, { children: _jsx("span", __assign({ className: "message-sent-status" }, { children: parentContext.chatPrefs.systemMessage
                                .CHAT_MESSAGE_OFFLINE_STATUS_MESSAGE })) })) }))) : (_jsx(_Fragment, {}))] })) }));
};
export default UserChatMessage;
